var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 4.696c-.405.185-.84.309-1.296.365.466-.287.824-.74.992-1.28a4.453 4.453 0 0 1-1.433.56 2.227 2.227 0 0 0-1.647-.73c-1.457 0-2.528 1.394-2.199 2.841-1.875-.096-3.538-1.017-4.651-2.417-.591 1.04-.307 2.4.698 3.09a2.205 2.205 0 0 1-1.022-.29c-.024 1.072.725 2.075 1.81 2.298a2.208 2.208 0 0 1-1.02.04c.288.919 1.121 1.588 2.11 1.606a4.457 4.457 0 0 1-3.342.96 6.274 6.274 0 0 0 3.46 1.039c4.19 0 6.557-3.629 6.414-6.884.44-.326.823-.734 1.126-1.198z"
  })));
};
export default SvgTwitter;